import { useEffect, useState } from 'react';

/**
 * Cycling "…" suffix for loading copy ("Generating image" → "." → ".." → "…").
 * Returns the dot string; render it in a fixed-width inline block so the text
 * before it doesn't shift as dots are added. Prefer <LoadingDots/>, which does
 * that for you — reach for the hook only when you need the raw string.
 */
export const useLoadingDots = (active = true, intervalMs = 300) => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    if (!active) {
      setDotCount(0);
      return;
    }
    const interval = setInterval(
      () => setDotCount((prev) => (prev + 1) % 4),
      intervalMs
    );
    return () => clearInterval(interval);
  }, [active, intervalMs]);

  return '.'.repeat(dotCount);
};
